
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import PreviewIcon from '@mui/icons-material/Preview';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import { baseUrl } from '../../utils/baseUrl';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  height: "90%",
  overflowY: "auto",
  width: { xs: '90%', md: "650px" },
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ViewModal({ item, FetchStyles }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title="Preview">
        <IconButton color='primary' onClick={handleOpen}>
          <PreviewIcon />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box position="absolute" top={10} right={0}>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <Stack my={1}>
            <Typography variant='h6'>Style: <Typography variant='h6' component={"span"} fontWeight={400}>{FetchStyles?.find((item1) => item1._id === item?.style)?.name}</Typography></Typography>
          </Stack>
          <Stack my={1}>
            <Typography variant='h6'>Name: <Typography variant='h6' component={"span"} fontWeight={400}>{item.name}</Typography></Typography>
          </Stack>
          <Stack my={1}>
            <Typography variant='h6'>Description: <Typography variant='h6' component={"span"} fontWeight={400}>{item?.description}</Typography></Typography>
          </Stack>
          <Stack my={1}>
            <Typography variant='h6'>Mid Journey Prompt: <Typography variant='h6' component={"span"} fontWeight={400}>{item?.midJourneyPrompt}</Typography></Typography>
          </Stack>
          {item.furnitureItems && item.furnitureItems?.map((item, index) => {
            return (
              <Stack my={1} key={index}>
                <Typography variant='h6'>Furniture {index + 1}</Typography>

                <Typography component={"small"} fontWeight={500}>Name: <Typography component={"small"} fontWeight={400}>{item?.name}</Typography></Typography>

                <Typography component={"small"} fontWeight={500}>Description: <Typography component={"small"} fontWeight={400}>{item?.description}</Typography> </Typography>
              
                <Box>
                  <Typography  fontWeight={500}>Image</Typography>
                  {item?.image &&
                    <img
                      src={`${baseUrl}/g${item?.image}`}
                      style={{
                        width: "90px",
                        height: "90px",
                        objectFit: "cover",
                      }}
                      alt="asdasd"
                      className="rounded"
                    />
                  }
                </Box>
                <Typography component={"small"} fontWeight={500}>Url: <Typography component={"small"} fontWeight={400}>{item?.url}</Typography> </Typography>

                <Typography component={"small"} fontWeight={500}>Embed Field: <Typography component={"small"} fontWeight={400}>{item?.embedField}</Typography> </Typography>
              </Stack>
            )
          })
          }
        </Box>
      </Modal>
    </>
  );
}
